var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserHeart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "user-heart-line",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.32,
    height: 32.32,
    viewBox: "0 0 32.32 32.32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1300",
    "data-name": "Path 1300",
    d: "M0,0H32.32V32.32H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1301",
    "data-name": "Path 1301",
    d: "M22.639,20.741l.237.238.24-.238A3.03,3.03,0,1,1,27.4,25.026L22.876,29.55l-4.522-4.524a3.03,3.03,0,0,1,4.285-4.285Zm-7.866-2.234V21.2a8.08,8.08,0,0,0-8.08,8.08H4A10.773,10.773,0,0,1,14.437,18.512ZM14.773,1a8.08,8.08,0,0,1,.3,16.155l-.3.005a8.08,8.08,0,0,1-.3-16.155Zm0,2.693A5.387,5.387,0,1,0,20.16,9.08,5.385,5.385,0,0,0,14.773,3.693Z",
    transform: "translate(1.387 0.347)",
    fill: "#0d5fa6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserHeart);
export default __webpack_public_path__ + "static/media/user-heart.93d85a58d798f7d8a325bfd231460598.svg";
export { ForwardRef as ReactComponent };